// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { ContentWithGlobalComponentsProperty } from './content/index.tsx';
import Modals from './modals/view.tsx';

const containerStyles = xcss({
	marginBottom: 'space.300',
});

export type Props = {};

// eslint-disable-next-line jira/react/no-class-components
export default class View extends PureComponent<Props> {
	render() {
		return (
			<Box xcss={containerStyles}>
				<ContentWithGlobalComponentsProperty />
				<Modals />
			</Box>
		);
	}
}
